import styled from '@emotion/styled';
import { BucketId, FileReference } from '@kaizenplatform/belfast-entity';
import { Button } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { lifecycle } from 'recompose';

import { ProjectDetailsForShowFragment } from '../../../generated/graphql';
import { ProjectForBrief } from '../../../graphql/project';
import { ProjectChangeType } from '../../../service/persistent/ProjectChangeWebApi';
import { SPACING_UNIT } from '../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';
import _CreativeBrief from './CreativeBrief';
import _ProjectTitle from './ProjectTitle';

type Props = ClassAttributes<HTMLElement> & {
  project: (ProjectDetailsForShowFragment & ProjectForBrief) | null;
  projectChange: ProjectChangeType | null;
  latestBriefFiles: Map<BucketId, FileReference[]>;
  beforeBriefFiles: Map<BucketId, FileReference[]>;
  assetFiles: ReadonlyArray<FileReference>;
  briefFiles: Map<BucketId, FileReference[]>;
  projectLoading: boolean;
  onClickPrevButton: () => void;
  onMount: () => void;
  onUnmount: () => void;

  className?: string;
};

const ProjectDiffPage = lifecycle<Props, Record<string, unknown>>({
  componentDidMount: function () {
    this.props.onMount();
  },
  componentWillUnmount: function () {
    this.props.onUnmount();
  },
})(
  ({
    project,
    projectChange,
    latestBriefFiles,
    beforeBriefFiles,
    assetFiles,
    briefFiles,
    projectLoading,
    onClickPrevButton,
    className,
  }: Props) => (
    <Root className={className}>
      <ProjectTitle project={project} loading={projectLoading} />

      <CreativeBrief
        project={project}
        projectChange={projectChange}
        latestBriefFiles={latestBriefFiles}
        beforeBriefFiles={beforeBriefFiles}
        assetFiles={assetFiles}
        briefFiles={briefFiles}
        loading={projectLoading}
      />
      <PrevButton variant="contained" color="primary" onClick={onClickPrevButton}>
        <FormattedMessage id="show_project_page.button.creative_brief_diff" />
      </PrevButton>
    </Root>
  ),
);
const Root = styled('div')({
  ...gridLayoutContainer({
    columns: ['100%'],
    rows: ['auto', 'auto', 'auto', 'auto'],
    areas: [['projectTitle'], ['creativeBrief'], ['button']],
  }),
  margin: `0 ${SPACING_UNIT}px`,
  padding: `${SPACING_UNIT * 5}px calc((100% - 960px) / 2) ${SPACING_UNIT * 10}px`,
});

const ProjectTitle = styled(_ProjectTitle)({ ...gridLayoutItem('projectTitle'), marginBottom: SPACING_UNIT * 3 });

const CreativeBrief = styled(_CreativeBrief)({ ...gridLayoutItem('creativeBrief'), marginBottom: SPACING_UNIT * 5 });

const PrevButton = styled(Button)({
  ...gridLayoutItem('button'),
  whiteSpace: 'nowrap',
});

export default ProjectDiffPage;
